export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
export const FILE_SIZE_ERROR = `File size should not exceed ${MAX_FILE_SIZE_MB}MB.`;

export const ALLOWED_ATTACHMENT_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv', 
];
export const ALLOWED_ATTACHMENT_ACCEPT = '.jpeg,.jpg,.png,.pdf,.doc,.docx,.xlsx,.csv';
export const ATTACHMENT_TYPE_ERROR =
  'Only .jpeg, .png, .pdf, .doc, .docx, .xlsx, .csv files are allowed.';

export const DUPLICATE_FILE_ERROR = 'This file is already attached.';

const getFileExtension = (file) => {
  const name = (file?.name || '').toLowerCase();
  return name.includes('.') ? `.${name.split('.').pop()}` : '';
};

export const isAllowedAttachmentType = (file) => {
  if (!file) return false;
  if (ALLOWED_ATTACHMENT_TYPES.includes(file.type)) return true;

  const extension = getFileExtension(file);
  if (file.type === 'application/vnd.ms-excel') return extension === '.csv';
  if (!file.type) return ALLOWED_ATTACHMENT_ACCEPT.split(',').includes(extension);
  return false;
};

export const isFileTooLarge = (file) => !!file && file.size > MAX_FILE_SIZE;

export const removeDuplicateFiles = (files, existingFiles = []) => {
  const isSameFile = (a, b) => a.name === b.name && a.data === b.data;
  return files.filter(
    (file, i) =>
      !existingFiles.some((existing) => isSameFile(existing, file)) &&
      files.findIndex((other) => isSameFile(other, file)) === i,
  );
};

export const filterFilesBySize = (files) => {
  const all = Array.from(files || []);
  const valid = all.filter((file) => !isFileTooLarge(file));
  return { valid, rejectedCount: all.length - valid.length };
};
